// extracted by mini-css-extract-plugin
export default {"root":"SFQfm","price":"TrRVs","saleOn":"k0H5+","selectPrimary":"gNLbg","highlightTitle":"_8Jyt-","tax":"JBp81","bottom":"iugYq"};